import type {CopilotAnnotations} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {createContext} from 'react'

interface ExtensionContext {
  isStreaming?: boolean
  chatMode?: 'assistive' | 'immersive'
  copilotAnnotations?: CopilotAnnotations
  wrapCodeLines?: boolean
  onWrapCodeLinesChange?: (wrap: boolean) => void
  /**
   * Called when the user activates a clickable suggestion (e.g. the PR reviewer "Want me to…" block).
   * Receives the suggestion's markdown source (inline formatting like `code` and links is preserved). `submit`
   * is true for a normal click (send the suggestion immediately) and false when the user holds Alt/Option
   * (pre-fill the chat input without sending). When omitted, suggestions render as plain list items.
   */
  onSuggestionSelect?: (suggestionText: string, options: {submit: boolean}) => void
}

/**
 * Shared context for React blocks to get state.
 */
export const ExtensionContext = createContext<ExtensionContext>({})
